import firebase from "firebase";

const settings = { timestampsInSnapshots: true };

const config = {
  apiKey: "AIzaSyArqwJ6qqPvhrYSJrTR3c_4WhWwTcKOFaM",
  authDomain: "carenting-8c923.firebaseapp.com",
  databaseURL: "https://carenting-8c923-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "carenting-8c923",
  storageBucket: "carenting-8c923.appspot.com",
  messagingSenderId: "630182838908",
  appId: "1:630182838908:web:1684612e5b5ec4d9937ff9",
  measurementId: "G-KVJGE10J18"
};
firebase.initializeApp(config);

firebase.firestore().settings(settings);

export default firebase;
